import React from "react";
import { gameAvailable, gameUnlockPoint } from "../../lib/numberSenseData";
import { Icon, Keys } from "../numberSenseUi";
import { GAMES, lockMessage } from "../NumberSenseGames";

/* ============================================================
   Number Sense — practice arcade hub: the grid of games, each
   shown locked or playable against the learner's unlock state.
   ============================================================ */
const GamesHub = ({ xp, gameData, onBack, onPlay }) => (
  <div className="ns-root">
    <div className="ns-app">
      <div className="subbar">
        <button className="iconbtn" onClick={onBack} aria-label="back">
          <Icon name="back" />
        </button>
        <div className="subbar-title">practice arcade</div>
        <div className="stat xp">
          <Icon name="bolt" />
          {xp}
        </div>
      </div>
      <div className="scroll">
        <p className="games-intro">
          A side-room for drilling. These play with the chords you've unlocked in
          lessons — no hearts, just for fun (and a little XP).
        </p>
        <div className="game-cards">
          {GAMES.map((g) => {
            const available = gameAvailable(g.kind, gameData.unlocked);
            const unlockAt = available ? null : gameUnlockPoint(g.kind);
            return (
              <button
                key={g.key}
                className={`game-card ${available ? "" : "locked"}`}
                disabled={!available}
                onClick={() => available && onPlay(g.key)}
              >
                <div className="ic">
                  <Icon name={available ? g.icon : "lock"} />
                </div>
                <div className="txt">
                  <div className="ttl">{g.title}</div>
                  <div className="kind">{g.sub}</div>
                  <div className="desc">
                    {available ? g.desc : lockMessage(g.kind)}
                  </div>
                  {!available && (
                    <div className="lock-badge">
                      <Icon name="lock" />
                      {unlockAt
                        ? `unlocks · unit ${unlockAt.unitNum} · lesson ${unlockAt.lessonNum}`
                        : "locked"}
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>
        <div className="footnote">
          <Keys />
        </div>
      </div>
    </div>
  </div>
);

export default GamesHub;
